<div class="p-8 bg-gradient-to-r from-orange-50 to-red-50 border-b-2 border-orange-400">
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
    <div class="bg-white p-5 rounded-lg border-l-4 border-orange-400 shadow-sm">
      <h3 class="text-red-800 font-poppins font-semibold mb-2">Organization Name</h3>
      <p class="text-gray-600 text-sm font-poppins">{{ organizationName || 'Not Available' }}</p>
    </div>

    <div class="bg-white p-5 rounded-lg border-l-4 border-orange-400 shadow-sm">
      <h3 class="text-red-800 font-poppins font-semibold mb-2">PAN Number</h3>
      <p class="text-gray-600 text-sm font-poppins">{{ pan || 'Not Available' }}</p>
    </div>

    <div class="bg-white p-5 rounded-lg border-l-4 border-orange-400 shadow-sm">
      <h3 class="text-red-800 font-poppins font-semibold mb-2">Primary Location</h3>
      <p class="text-gray-600 text-sm font-poppins">{{ computedPrimaryLocation }}</p>
    </div>

    <div class="bg-white p-5 rounded-lg border-l-4 border-orange-400 shadow-sm">
      <h3 class="text-red-800 font-poppins font-semibold mb-2">NGO Type</h3>
      <p class="text-gray-600 text-sm font-poppins">{{ ngoType }}</p>
    </div>

    <div class="bg-white p-5 rounded-lg border-l-4 border-orange-400 shadow-sm">
      <h3 class="text-red-800 font-poppins font-semibold mb-2">District</h3>
      <p class="text-gray-600 text-sm font-poppins">{{ computedDistrict }}</p>
    </div>

    <div class="bg-white p-5 rounded-lg border-l-4 border-orange-400 shadow-sm">
      <h3 class="text-red-800 font-poppins font-semibold mb-2">CSR-1</h3>
      <p class="text-gray-600 text-sm font-poppins">{{ csr1Display }}</p>
    </div>
  </div>
</div>

